export default "__VITE_ASSET__Ck8ss8C4__"